module.exports = __webpack_public_path__ + "img/悦颜.ccd89e2.png";